/* eslint-disable array-callback-return */
import { useState, useEffect, Fragment } from "react";
import differentOddService from "../../services/differentOddService";
import {FormGroup,FormControlLabel,Checkbox,IconButton,Box,TextField} from '@mui/material';
import moment from "moment";
import { FaFutbol,FaEye } from "react-icons/fa";
import {OddHistory,EventInfo} from "./components";
import { LoadingSpinner } from "../../components";
import { useWindowWidth } from '@react-hook/window-size';
import DiffOddMobile from "./mobile/DiffOddMobile";
import HeaderTitle from "../../components/HeaderTitle";

const title = ["555 EVENTS", "909 EVENTS"];

function DifferentOdd() {
  const defaultDate = moment(new Date()).format("YYYY-MM-DD");
  const onlyWidth = useWindowWidth();
  const [selectedDate, setselectedDate] = useState(defaultDate);
  const [eventList, setEventList] = useState([]);
  const [showEventList, setShowEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [eventId,setEventId] = useState(0);
  const [text,setText] = useState([]);

  useEffect(() => {
    getDifferentOdd();
    // eslint-disable-next-line
  }, [selectedDate])

  const getDifferentOdd = async () => {
    try {
      setIsLoading(true);
      const selected_date = selectedDate === "" ? defaultDate : selectedDate;
      const differentOddList = await differentOddService.getDifferentOdd(selected_date);
      //console.log("data>>>", differentOddList);
      setEventList(differentOddList.data.data);
      setShowEventList(differentOddList.data.data);
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  }

  const handleChange = (event) => {
    const temp = event.target.checked ? eventList.filter(value => value.is_body_diff || value.is_goal_diff) : eventList;
    console.log("temp", event)
    setShowEventList(temp);
  };

  const handleClickOpen = (id) => {
    setEventId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setEventId(0);
    setOpen(false);
  };

  const handleTextChange = (searchedVal) => {
    const filteredRows = eventList.filter((row) => {
      return (
        row.event_555_home.toLowerCase().includes(searchedVal.toLowerCase()) ||
        row.event_555_away.toLowerCase().includes(searchedVal.toLowerCase())
      );
    });
    setShowEventList(filteredRows);
    setText(searchedVal);
  }

  return (
    <div>
      <header className="bg-white dark:bg-custom_dark_background shadow mb-1">
        <div className="mx-auto max-w-7xl px-4 py-1 sm:px-6 lg:px-8">
          <div className="flex justify-between">
            {/* <h3 className="text-2xl font-bold tracking-tight text-customForeColor">
              Different Odd
            </h3> */}
             <HeaderTitle title={"Different Odd"} width={onlyWidth} />
          </div>
          <div className="flex flex-wrap justify-between items-center w-[99%] gap-1">
            <div className="flex gap-2 items-center dark:text-customWhite">
              <TextField
                id="date"
                label="Start Date :"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
                className="dark:text-customWhite"
                value={selectedDate || defaultDate}
                onChange={(e) => setselectedDate(e.target.value)}
              />
              <span className="font-bold dark:text-customWhite">Total : {eventList.length}</span >
            </div>
            <div className="flex items-center dark:text-customWhite">
              <Box
                component="form"
                sx={{
                  '& > :not(style)': { m: 1, width: onlyWidth < 480 ? '15ch' : '25ch' },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="standard-basic"
                  className="dark:text-customWhite"
                  label="Search Team Name ... "
                  variant="standard"
                  onChange={(e) => handleTextChange(e.target.value)}
                  value={text}
                />
              </Box>
              <FormGroup>
                <FormControlLabel className="dark:text-customWhite" control={<Checkbox />} label="Odd Different" onChange={(e) => handleChange(e)} />
              </FormGroup>
            </div>
          </div>
        </div>
      </header>
      <main>
        {
          isLoading ? <LoadingSpinner />
            :
            onlyWidth > 480 ?
            <Fragment>
              <div className="mx-auto max-w-7xl py-1 sm:px-6 lg:px-8">
                <div className="flex justify-center w-[99%] gap-1">
                  {
                    title.map((v, i) => {
                      return (
                        <div className="flex flex-col w-[45%] max-w-[45%] rounded" key={i}>
                          <div className="w-full text-center bg-background text-white dark:bg-custom_dark_primary2 dark:text-customWhite py-2 text-base dark:border-custom_dark_primary">
                             {v}
                          </div>
                        </div>
                        )
                     })
                   }
                </div>
              </div>
              {
                showEventList && showEventList.map((v, i) => {
                  return (
                    <div className="mx-auto max-w-7xl py-1 sm:px-6 lg:px-8" key={i}>
                      <div className="mx-auto flex justify-between items-center w-[88%] text-sm text-background">
                        <div className="flex gap-1 items-center text-customFontGreen">
                          <FaFutbol />
                          <span>
                            {moment(v.event_time.value).format('DD-MM-YYYY hh:mm a')}
                          </span>
                        </div>
                        <IconButton onClick={()=>handleClickOpen(v.event_Id_555)} size="small" className="dark:text-customWhite">
                        <FaEye/>
                        </IconButton>
                      </div>
                      <div className="flex justify-center w-[99%] gap-1">
                        <EventInfo
                          homeTeamName={v.event_555_home}
                          awayTeamName={v.event_555_away}
                          homeOdd={v.home_odd_555}
                          awayOdd={v.away_odd_555}
                          goalOdd={v.goal_odd_555}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                        />

                        <EventInfo
                          homeTeamName={v.event_909_home}
                          awayTeamName={v.event_909_away}
                          homeOdd={v.home_odd_909}
                          awayOdd={v.away_odd_909}
                          goalOdd={v.goal_odd_909}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                        />
                      </div> 
                    </div>
                  )
                })
              }
            </Fragment>
            : <DiffOddMobile showEventList={showEventList}/>
        }
        
        {
            eventId !== 0  ? <OddHistory open={open} handleClose={handleClose} eventId={eventId} selectedDate={selectedDate}/> : null
         } 

      </main>
    </div>
  );
}

export default DifferentOdd;



